/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InternshipApplication } from '../../models/internship-application';

export interface GetStudentInternshipApplication$Params {
  profileId: string;
  id: string;
}

export function getStudentInternshipApplication(http: HttpClient, rootUrl: string, params: GetStudentInternshipApplication$Params, context?: HttpContext): Observable<StrictHttpResponse<InternshipApplication>> {
  const rb = new RequestBuilder(rootUrl, getStudentInternshipApplication.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InternshipApplication>;
    })
  );
}

getStudentInternshipApplication.PATH = '/studentprofile/{profileId}/internshipapplications/{id}';
